/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {FormikValues} from 'formik'
import MuiPhoneNumber from 'material-ui-phone-number'

interface subdivisionsDataType {
  property_sub_unit_uuid: string
  property_unit_description: string
  property_unit_max_tenants: number
  property_unit_name: string
  property_unit_rent: string
}
const AddTenantStep3 = ({formik, subDivisions}: FormikValues) => {
  return (
    <div data-kt-stepper-element='content'>
      <div className='w-100'>
        {/*begin::Form Group Room number */}
        {subDivisions?.length > 0 && (
          <div className='fv-row mb-6'>
            <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
              <span className='required'>Subdivision</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Choose subdivision'
              ></i>
            </label>
            <select
              className='form-select form-select-solid'
              name='property_sub_unit_uuid'
              placeholder='Select subdivision'
              {...formik.getFieldProps('property_sub_unit_uuid')}
            >
              <option className='bg-color-gray' value=''>
                Select subdivision
              </option>
              {subDivisions.map((item: subdivisionsDataType) => {
                return (
                  <option key={item.property_sub_unit_uuid} value={item.property_sub_unit_uuid}>
                    {item.property_unit_name}
                  </option>
                )
              })}
            </select>
            <div className='h-20px'>
              {formik.touched.property_sub_unit_uuid && formik.errors.property_sub_unit_uuid && (
                <div className='fv-help-block color-red'>
                  {formik.errors.property_sub_unit_uuid}
                </div>
              )}
            </div>
          </div>)}
        {/*end::Form Group Room number*/}
        {/*begin::Form Group Rent Amount */}
        <div className='fv-row mb-6'>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span className='required'>Rent Amount</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Enter rent amount'
            ></i>
          </label>
          <input
            type='text'
            className='form-control form-control-lg form-control-solid'
            name='property_rent_rate'
            placeholder='Enter rent amount'
            {...formik.getFieldProps('property_rent_rate')}
          />
          <div className='h-20px'>
            {formik.touched.property_rent_rate && formik.errors.property_rent_rate && (
              <div className='fv-help-block color-red'>{formik.errors.property_rent_rate}</div>
            )}
          </div>
        </div>
        {/*end::Form Group Rent Amount*/}
        {/*begin::Form Group Security Deposit */}
        <div className='fv-row mb-6'>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span className=''>Security Deposit</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Enter security deposit amount'
            ></i>
          </label>
          <input
            type='text'
            className='form-control form-control-lg form-control-solid'
            name='security_deposit'
            placeholder='Enter security deposit amount'
            {...formik.getFieldProps('security_deposit')}
          />
          <div className='h-20px'>
            {formik.touched.security_deposit && formik.errors.security_deposit && (
              <div className='fv-help-block color-red'>{formik.errors.security_deposit}</div>
            )}
          </div>
        </div>
        {/*end::Form Group Security Deposit*/}
      </div>
    </div>
  )
}

export default AddTenantStep3
